/** Global questionnaire availability; actions persist through V1 approval rules. */
import React from 'react';
import { Button, Label, Segment } from 'semantic-ui-react';

export default function QuestionnaireStatusCard({ saved, isNew, onChange, busy = false }) {
  const active = saved.status === 'active' && saved.isActive === true;
  const review = saved.status === 'underReview';
  const tone = active ? 'active' : review ? 'review' : 'inactive';
  return (
    <Segment
      className={`questionnaire-card questionnaire-status-card status-${tone}`}
      aria-label="Questionnaire status"
    >
      <div className="questionnaire-status-row">
        <h3 title="Controls availability across WhatsApp, the mobile app and other questionnaire entry points.">
          Status
        </h3>
        <Label color={active ? 'green' : review ? 'orange' : 'grey'}>
          {active ? 'Active' : review ? 'Awaiting approval' : 'Inactive'}
        </Label>
        <Button type="button" disabled={isNew || busy} loading={busy} onClick={onChange}>
          {saved.status === 'underReview'
            ? 'Withdraw from review'
            : saved.isActive
              ? 'Deactivate'
              : 'Submit for approval'}
        </Button>
      </div>
      {isNew && <p>Save the questionnaire before submitting it for approval.</p>}
    </Segment>
  );
}
